<template>
  <Dialog
    :focusTrap="true"
    v-model:visible="taskComment"
    style="width: 30%; max-height: 100%"
    @hide="CloseTaskCommentModal()"
    :modal="true"
  >
    <template #header>
      <h4 class="modal-title" id="myModalLabel">Add A Task</h4>
    </template>
    <div>
      <form>
        <div class="form-group">
          <label for="comment-text" class="control-label">Comment:</label>
          <textarea
            class="form-control"
            id="comment-text"
            v-model="comment"
          ></textarea>
        </div>

        <div class="row mb-4">
          <button
            @click="SaveComment()"
            type="button"
            class="
              btn btn-outline-success
              waves-effect waves-light
              col-12
              commentlefttasks
            "
          >
            Leave Comment
          </button>
        </div>
        <div class="form-group">
          <div v-for="(comment, index) in taskComments" :key="index">
            <div class="timeline-panel">
              <div class="timeline-heading">
                <h4 class="" style="font-size: 20px; font-weight: 800">
                  {{ comment.userName }}
                </h4>
                <p style="margin-top: -10px">
                  <small class="text-muted">
                    <i class="fa fa-clock-o"></i>{{ comment.createdDateStr }}
                  </small>
                </p>
              </div>
              <div class="timeline-body">
                <p>{{ comment.comment }}</p>
              </div>
            </div>
            <hr class="solid bg-white" />
          </div>
        </div>
      </form>
    </div>
  </Dialog>
</template>
<script>
import axios from "axios";
import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";
import Swal from "sweetalert2";
export default {
  name: "TaskTable",
  props: ["tableRefreash", "visitId", "closeModal", "patientTask"],
  setup() {},
  data() {
    return {
      taskComment: true,
      TimerObject: null,
      visitTaskId: 0,
      comment: "",
      taskComments: [],
    };
  },
  methods: {
    CloseTaskCommentModal() {
      this.closeModal();
    },
    callGetComment(id, pt) {
      this.GetComment(id, pt);
    },
    async GetComment(id, pt) {
      this.comment = "";
      this.taskComments = [];
      this.visitTaskId = id;
      this.intDummyComm();
      const obj = {
        DC: this.dummyComm,
        VisitTaskId: this.visitTaskId,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/GetTaskComments",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.taskComments = myData.data;
          } else {
            this.errorToast("Unable to undate information");
          }
        })
        .finally(() => {
          this.tableRefreash();
        });
    },
    async SaveComment() {
      debugger;
      this.intDummyComm();
      console.log(this.patientTask);
      this.dummyComm.visitId = this.patientTask.visitId;
      this.dummyComm.patientId = this.patientTask.patientId;
      const obj = {
        DC: this.dummyComm,
        TaskId: this.patientTask.taskID,
        VisitTaskId: this.visitTaskId,
        Comment: this.comment,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/InsertTaskComment",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.taskComments = myData.data;
          } else {
            this.errorToast("Unable to undate information");
          }
        })
        .finally(() => {
          this.GetComment(this.visitTaskId);
        });
    },
    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
  },
  mounted() {
    if (this.visitId !== undefined) {
      this.GetComment(this.visitId);
    }
  },
};
</script>